import {
    DialogTitle,
    Dropdown,
    Flex,
    Icon,
    Text,
    PriorityIcon
} from '@priority-software/priority-style-react';
import React, {Component} from 'react';
import {keyCodes} from '../../../../constants';
import {DialogModal} from '../../../../_shared/componnets/Dialog/Dialog';
import {
    openNavigationModal,
    returnFocus,
    setIsNavigationEnabled
} from '../../../../_shared/GWTBridge/invoke/genPage';
import {setIsReactPopupOpen} from '../../../../_shared/GWTBridge/invoke/netForm';
import {getTopDialogZindex} from '../../../../_shared/GWTBridge/invoke/priModalDlg';
import {highlightText} from '../../../../_legacy/library/utils/highlightText';
import EntityIcon from '../../EntityIcon/EntityIcon';
import texts from '../text';
import {SearchDropdown} from '../../../../_legacy/FormHeader/components/Search/SearchDropdown';
import List from '../../List';
import {helpPopoverRef} from '../../../../_shared/Help/constants';
import {showEntityHelpMessage} from '../../../../_shared/Help/actions/helpActions';
import {listType} from '../enums';
import {ModalFooter} from './ModalFooter';
import styles from '../styles/selectList.module.scss';

interface Item {
    title: string;
    type: string;
    action: any;
    menuButton: any;
    exec: any;
}

interface SelectListModalState {
    searchValue: string;
    isOpen: boolean;
    items: Item[];
    filterdItems: Item[];
    selectedIndex: number;
    listType: listType;
}

export class SelectListModal extends Component<any, SelectListModalState> {
    defaultState: SelectListModalState = {
        searchValue: '',
        isOpen: false,
        items: [],
        filterdItems: [],
        selectedIndex: 0,
        listType: null
    };
    state = {
        ...this.defaultState
    };
    helpButtonRef: any = React.createRef();
    itemsRef = [];

    showDialog = (items, listType) => {
        this.setState({listType, items, filterdItems: items, isOpen: true});
        setIsReactPopupOpen(true);
        setIsNavigationEnabled(false);
        window.addEventListener('keydown', this.handleKeydown, true);
    };

    handleKeydown = e => {
        if (e.ctrlKey && (e.keyCode === keyCodes.ARROW_DOWN || e.keyCode === keyCodes.ARROW_UP)) {
            this.handleClose();
            openNavigationModal(e.keyCode === keyCodes.ARROW_DOWN);
        }
    };
    handlePageDown = selectedIndex => {
        const lastIndex = this.state.filterdItems.length - 1;
        let nextIndex = selectedIndex + 10;
        nextIndex = nextIndex > lastIndex ? lastIndex : nextIndex;
        return Promise.resolve({nextSelected: nextIndex});
    };

    handlePageUp = selectedIndex => {
        let nextIndex = selectedIndex - 10;
        nextIndex = nextIndex >= 0 ? nextIndex : 0;
        return nextIndex;
    };
    handleInputChange = (value: string) => {
        const {items} = this.state;
        const filterdList =
            value === ''
                ? items
                : items.filter(item => item.title.toLowerCase().includes(value.toLowerCase()));
        this.setState({searchValue: value, filterdItems: filterdList, selectedIndex: 0});
    };

    handleItemClick = (event, index) => {
        this.setState({selectedIndex: index}, () => {
            if (event.keyCode === keyCodes.ENTER && !helpPopoverRef?.current?.state.open) {
                if (
                    event?.target?.name === 'cancel' ||
                    event?.target?.name === 'help' ||
                    event?.target?.ariaLabel === 'Close'
                ) {
                    event.target.click();
                } else {
                    this.handleAccept();
                }
            }
        });
    };

    handleCloseHelpMessage = () => {
        helpPopoverRef?.current?.onClose();
        if (this.helpButtonRef?.current) {
            this.helpButtonRef.current?.focus();
        }
    };
    handleShowHelpMessage = index => {
        const item = this.state.filterdItems[index];
        if (item) {
            const {exec} = item;
            showEntityHelpMessage(exec, this.itemsRef[index], this.handleClose);
        }
    };
    handleAccept = () => {
        const {selectedIndex, filterdItems} = this.state;
        const item = filterdItems[selectedIndex];
        if (item) {
            const {action, menuButton} = item;
            this.handleClose();
            action && action(menuButton);
        }
    };

    handleSelectAndAccept = index => {
        this.setState({selectedIndex: index}, () => {
            this.handleAccept();
        });
    };
    handleClose = () => {
        this.setState({
            ...this.defaultState
        });
        setIsReactPopupOpen(false);
        setIsNavigationEnabled(true);
        returnFocus();
        window.removeEventListener('keydown', this.handleKeydown, true);
    };
    renderTitle = () => {
        return <DialogTitle title={texts[this.state.listType]} textColor="primary-700" />;
    };

    renderContent = () => {
        const {filterdItems, items, searchValue, selectedIndex} = this.state;

        return (
            <SearchDropdown
                circularNavigation
                open={true}
                eventTypes={[]}
                closeOnESC={false}
                closeOnBlur={false}
                shouldHandleHomeAndEndPress={true}
                closeOnClear={false}
                clearOnClose={false}
                withArrowIcon={false}
                handlePageDown={this.handlePageDown}
                handlePageUp={this.handlePageUp}
                focusedIndex={selectedIndex}
                withTriggerWrapper={false}
                inputProps={{
                    componentClasses: items.length < 9 && styles.hideInput,
                    prefixIcon: <Icon iconColor="primary-500" icon={PriorityIcon.searchThin} />,
                    size: 'large',
                    onChange: this.handleInputChange,
                    value: searchValue
                }}
            >
                <div>
                    <div className={styles.list}>
                        {filterdItems.length > 0 ? (
                            <List renderItem={this.renderItem} data={filterdItems} />
                        ) : (
                            <Dropdown.Item disabled>
                                <Flex>
                                    <Text skin="paragraph-2">
                                        {texts[this.state.listType + 'NoResults']}
                                    </Text>
                                </Flex>
                            </Dropdown.Item>
                        )}
                    </div>
                    <ModalFooter
                        handleAccept={this.handleAccept}
                        handleClose={this.handleClose}
                        handleShowHelpMessage={this.handleShowHelpMessage}
                        helpButtonRef={this.helpButtonRef}
                    />
                </div>
            </SearchDropdown>
        );
    };
    renderItem = ({item, index}) => {
        const {type, title} = item;
        return (
            <Dropdown.Item
                key={index + title}
                index={index}
                closeOnClick={false}
                divider
                onRef={ref => (this.itemsRef[index] = ref)}
                focusOnSelect
                onClick={event => this.handleItemClick(event, index)}
                onDoubleClick={() => this.handleSelectAndAccept(index)}
            >
                <Flex justifyContent="flex-start">
                    {this.state.listType === listType.DirectActivations && (
                        <EntityIcon type={type} />
                    )}
                    <Text startPadding textColor="primary-700" skin="subtitle-2">
                        {highlightText(title, this.state.searchValue)}
                    </Text>
                </Flex>
            </Dropdown.Item>
        );
    };

    render() {
        const {isOpen} = this.state;
        if (isOpen) {
            return (
                <DialogModal
                    isDialogOpen={isOpen}
                    content={this.renderContent()}
                    onClose={this.handleClose}
                    title={this.renderTitle()}
                    width={718}
                    size={'large'}
                    draggable={true}
                    zIndex={getTopDialogZindex()}
                />
            );
        } else {
            return null;
        }
    }
}
